<template>
	<div class="text-sm">
		<button v-if="isSubscribed" @click.prevent="unsubscribe"
				class="btn btn-default btn-md flex justify-start items-center space-x-2"
				title="Отписаться">
			<svg-icon icon="person-dash-fill" class="w-5 h-5"></svg-icon>
		</button>

		<button v-else @click.prevent="subscribe"
				class="btn btn-default btn-md flex justify-start items-center space-x-2"
				title="Подписаться">
			<svg-icon icon="person-plus-fill" class="w-5 h-5"></svg-icon>
		</button>
	</div>
</template>
<script>
import Client from "../../js/modules/Client";
import {notify} from "@kyvg/vue3-notification";

export default {
	props: [
		'subscribed',
		'type',
		'id',
		'compact',
	],
	data() {
		return {
			isSubscribed: this.subscribed || false,
		};
	},
	methods: {
		subscribe() {
			this.isSubscribed = true;

			notify({
				type: 'success',
				text: 'Вы подписаны',
			})

			Client.post(this.getUrl())
				.then(response => {
					this.isSubscribed = response.data.is_subscribed;
				})
				.catch(error => {
					notify({
						type: 'error',
						text: 'Что-то пошло не так',
					});
				});
		},
		unsubscribe() {
			this.isSubscribed = false;

			notify({
				type: 'success',
				text: 'Вы отписаны',
			})

			Client.delete(this.getUrl())
				.catch(error => {
					notify({
						type: 'error',
						text: 'Что-то пошло не так',
					});
				});
		},
		getUrl() {
			return '/api/v1.1/' + this.type + '/' + this.id + '/subscribe';
		}
	}
}
</script>
